import { Button, Checkbox, Input } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { ContentBox } from "../../components/layout/content";
import { LoginedLayout } from "../../components/layout/loginLayout";
import { HeaderTitle } from "../../components/styled-components";
import { GET } from "../../services";
import { GETWAITHOLD } from "../../services/path";

interface OrderData {
  invoiceNo: string;
  orderNo: string;
  SoNo: string;
  optStatusID: number;
}

const HolderPage = () => {
  const [selectedOrderNos, setSelectedOrderNos] = useState<string[]>([]);
  const [data, setData] = useState<OrderData[]>([]);
  const generateColumn = (
    title: string,
    dataIndex: keyof OrderData,
    key: keyof OrderData,
    filterable = false,
    responsive?: ("xs" | "sm" | "md" | "lg" | "xl" | "xxl")[],
  ): ColumnsType<OrderData>[0] => ({
    title,
    dataIndex,
    key,
    responsive,
    sorter: (a: OrderData, b: OrderData) => {
      const aValue = a[dataIndex] ?? "";
      const bValue = b[dataIndex] ?? "";
      return aValue.toString().localeCompare(bValue.toString());
    },
    render: (value) => {
      if (dataIndex === "optStatusID") {
        if (value === 7) return "waiting";
        if (value === 10) return "hold";
      }

      return value;
    },
    ...(filterable && {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${title}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      onFilter: (value: string | number | boolean | bigint, record: OrderData) => {
        return record[dataIndex]?.toString().toLowerCase().includes(value.toString().toLowerCase());
      },
    }),
  });

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      // Add all order numbers when selecting all
      const allOrderNos = data.map((record) => record.orderNo);
      setSelectedOrderNos(allOrderNos);
    } else {
      // Clear the selection when deselecting all
      setSelectedOrderNos([]);
    }
  };

  const isRowSelected = (orderNo: string) => selectedOrderNos.includes(orderNo);
  const isAllSelected = data.length > 0 && selectedOrderNos.length === data.length;
  const columns: ColumnsType<OrderData> = [
    {
      title: (
        <>
          <Checkbox onChange={(e) => handleSelectAll(e.target.checked)} checked={isAllSelected} />
          <span style={{ marginLeft: 8 }}>Select All</span>
        </>
      ),
      dataIndex: "select",
      key: "select",
      render: (_, record: OrderData) => (
        <Checkbox
          checked={isRowSelected(record.orderNo)}
          onChange={(e) => handleCheckboxChange(record.orderNo, e.target.checked)}
        />
      ),
    },
    generateColumn("Order", "orderNo", "orderNo", true, ["sm"]),
    generateColumn("SO", "SoNo", "SoNo", true, ["sm"]),
    generateColumn("Inv No", "invoiceNo", "invoiceNo", true, ["sm"]),
    generateColumn("Type", "optStatusID", "optStatusID", true, ["sm"]),
  ];

  const handleCheckboxChange = (order_no: string, checked: boolean) => {
    setSelectedOrderNos((prev) =>
      checked ? [...prev, order_no] : prev.filter((no) => no !== order_no),
    );
  };

  const fetchorderwait = async () => {
    try {
      const resultwait = await GET(GETWAITHOLD);
      if (resultwait.result.length > 0) {
        const filteredData = resultwait.result.filter((item: OrderData) => item.optStatusID === 10);
        setData(filteredData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchorderwait();
  }, []);

  return (
    <LoginedLayout>
      <ContentBox>
        <HeaderTitle>
          <h2>Hold Order</h2>
        </HeaderTitle>
        <div>
          <Table
            columns={columns}
            dataSource={data} // assuming data is defined
            scroll={{ x: "max-content" }} // to allow horizontal scroll if needed
            style={{
              width: "100%",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }} // ensuring the table width is responsive
            tableLayout="fixed" // fix table layout to avoid data overflow
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          ></div>
        </div>
      </ContentBox>
    </LoginedLayout>
  );
};

export default HolderPage;
